/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getUserTagTable = params => {
  return axios.post(`${base}/query_tag`, params)
}
export const getUserGroupTagTable = params => {
  params.is_group = 1
  return axios.post(`${base}/query_tag`, params)
}
export const getUserNormalTagTable = params => {
  params.is_normal_tag = 0
  return axios.post(`${base}/query_tag`, params)
}
export const getUserTagDetail = params => {
  return axios.get(`${base}/tag_${params.id}`, {params})
}
export const createUsertag = params => {
  return axios.post(`${base}/create_tag`, params)
}
export const updateUsertag = params => {
  return axios.post(`${base}/update_tag_${params.id}`, params)
}
export const deleteUsertag = params => {
  return axios.post(`${base}/delete_tag_${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/user-tag/userTag.api.js